import { isFedRamp } from '@atlassian/atl-context';

import measurePerformance, { PerformanceMetric } from '../util/measurePerformance';

import {
  FlightDeckProductConfigurationArtifact,
  resolvedFlightDeckClient,
  transformFlightDeckArtifactToProductConfiguration,
} from './flight-deck-utils';
import { ProductConfigurationResponse } from './sites/model';

export const FEDRAMP_PERIMETER = 'fedramp-moderate';
export const COMMERCIAL_PERIMETER = 'commercial';

async function getProductConfigurationFlightDeck(): Promise<ProductConfigurationResponse> {
  const artifact = (await resolvedFlightDeckClient.fetchConfigFromFlightDeck({
    name: 'app-switcher-fe',
    dimensions: {
      environmentType: 'prod',
      perimeter: isFedRamp() ? FEDRAMP_PERIMETER : COMMERCIAL_PERIMETER,
    },
  })) as FlightDeckProductConfigurationArtifact;
  const data = transformFlightDeckArtifactToProductConfiguration(artifact);

  return data;
}
class ProductConfigurationClient {
  async getProductConfiguration({ retryMS }: { retryMS: number[] }): Promise<ProductConfigurationResponse> {
    return measurePerformance(
      PerformanceMetric.ProductConfigurationService,
      () => getProductConfigurationFlightDeck(),
      retryMS,
    );
  }
}

export default new ProductConfigurationClient();
